import classNames from "classnames";
import PropTypes from "prop-types";
import React from "react";

import EbookDownloadIcon from "../../../../../lib/StrategyDashboard/assets/ebook-download.svg";
import withTranslations from "../../../../../hocs/withTranslations";
import PdfImage from "../../../../../lib/StrategyDashboard/assets/jak-korzystac-ze-strategii-squabera.png";

const EBOOK_TITLE_KEY = "sid_dashboard_pdf_banner_item_1_title";
const EBOOK_SUBTITLE_KEY = "sid_dashboard_ebook_card_subtitle";
const EBOOK_BUTTON_HREF_KEY = "sid_dashboard_pdf_banner_button_href";
const EBOOK_BUTTON_LABEL_KEY = "sid_dashboard_pdf_banner_button_label";

const StrategyEbookCard = ({ className, translate, translationExists }) => {
  const hasTitle = translationExists(EBOOK_TITLE_KEY);
  const buttonHref = translationExists(EBOOK_BUTTON_HREF_KEY)
    ? translate(EBOOK_BUTTON_HREF_KEY)
    : null;

  if (!hasTitle || !buttonHref) {
    return null;
  }

  const hasSubtitle = translationExists(EBOOK_SUBTITLE_KEY);
  const hasButtonLabel = translationExists(EBOOK_BUTTON_LABEL_KEY);

  return (
    <div className={classNames("relative w-full", className)}>
      <img
        className="absolute left-4 -top-2.5 z-10 object-cover rounded-0.75"
        src={PdfImage}
        width={46}
        alt=""
      />
      <div className="flex items-center gap-3 w-full mt-3.5 pr-4 py-2.5 pl-19.5 rounded bg-white">
        <div className="flex-1 flex flex-col min-w-0 gap-1">
          <ul className="ul-1_check m-0">
            <li>
              <span className="text-sm font-semibold leading-100 text-black">
                {translate(EBOOK_TITLE_KEY)}
              </span>
            </li>
          </ul>
          {hasSubtitle ? (
            <p className="text-xs font-medium leading-140 m-0 mt-1 pl-8 italic text-black-7">
              {translate(EBOOK_SUBTITLE_KEY)}
            </p>
          ) : null}
        </div>
        <a
          className="flex shrink-0 items-center justify-center no-underline hover:opacity-85 h-11 w-11 rounded-1xl"
          href={buttonHref}
          target="_blank"
          rel="noopener noreferrer"
          aria-label={
            hasButtonLabel ? translate(EBOOK_BUTTON_LABEL_KEY) : undefined
          }
        >
          <img
            className="block"
            src={EbookDownloadIcon}
            width={24}
            height={24}
            alt=""
            aria-hidden
          />
        </a>
      </div>
    </div>
  );
};

StrategyEbookCard.propTypes = {
  className: PropTypes.string
};

export default withTranslations(StrategyEbookCard);
